import { render } from "./Sponsor.vue?vue&type=template&id=4cdf6aa9&scoped=true"
import script from "./Sponsor.vue?vue&type=script&lang=js"
export * from "./Sponsor.vue?vue&type=script&lang=js"

import "./Sponsor.vue?vue&type=style&index=0&id=4cdf6aa9&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4cdf6aa9"

export default script